import { render, staticRenderFns } from "./PasswordRecoveryPage.vue?vue&type=template&id=6c6d2ac4&"
import script from "./PasswordRecoveryPage.vue?vue&type=script&lang=js&"
export * from "./PasswordRecoveryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports